export default function TermsOfServicePage() {
  return (
    <div className="card">
      <h2>Terms of Service – SiftMyMail</h2>
      <p>
        <strong>Effective date:</strong> December 15, 2025
      </p>
      <p>By using SiftMyMail, you agree to the following terms.</p>
      <ol>
        <li>
          <strong>Service Description</strong>
          <p>
            SiftMyMail is a privacy-focused email analysis tool provided by Christy and Ryan, LLC. SiftMyMail provides
            informational risk indicators for emails. The service is provided “as is” and may change or be discontinued at
            any time.
          </p>
        </li>
        <li>
          <strong>User Responsibilities</strong>
          <p>
            Users agree to use the service only with accounts they own or are authorized to access and not to misuse or
            interfere with the service.
          </p>
        </li>
        <li>
          <strong>No Guarantees</strong>
          <p>SiftMyMail does not guarantee detection of all malicious or phishing emails. Users remain responsible for decisions based on the app’s output.</p>
        </li>
        <li>
          <strong>Donations</strong>
          <p>SiftMyMail operates on a donation-supported model. Donations are voluntary and do not guarantee features, support, or availability.</p>
        </li>
        <li>
          <strong>Limitation of Liability</strong>
          <p>To the maximum extent permitted by law, Christy and Ryan, LLC is not liable for damages arising from use of the service.</p>
        </li>
        <li>
          <strong>Governing Law</strong>
          <p>These terms are governed by the laws of the State of Texas, United States.</p>
        </li>
        <li>
          <strong>Contact</strong>
          <p>Email: christy--ryan-app-support@googlegroups.com</p>
          <p>Christy and Ryan, LLC — Texas, United States</p>
        </li>
      </ol>
    </div>
  );
}
